module.exports = __webpack_public_path__ + "static/img/zhaorui.7c3ce31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhaorui.jpg
// module id = Qo50
// module chunks = 1